import WizardModalWrapperLayout from 'Views/Page/Content/Modal/Layouts/WizardModalWrapperLayout';
import React from 'react';
import Content from './Content';

const Layout = () => {
  return (
    <WizardModalWrapperLayout>
      <Content />
    </WizardModalWrapperLayout>
  );
};

export default Layout;
